import { render, staticRenderFns } from "./AddBase.vue?vue&type=template&id=b5725282"
import script from "./AddBase.vue?vue&type=script&lang=js"
export * from "./AddBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports